import React from 'react';
import { BENEFITS } from '../../data/benefitsData';
import './BenefitsSection.css';

export default function BenefitsSection({ selectedId, onSelect }) {
  const b = BENEFITS.find((x) => x.id === selectedId);
  return (
    <>
      <div className="benefits-header">
        <h2 className="benefits-header__title">8<span className="font-body-inline">+</span> benefits of Premsi</h2>
        <img loading="lazy" src={require('../../images/pblue-min.webp')} className="benefits-header__icon" alt="Premsi.com logo app icon" />
      </div>
      <p className="benefits-header__subtitle">4+ different income streams with Premsi</p>

      <div className="benefits-strip" role="tablist" aria-label="Benefits">
        {BENEFITS.map((item) => (
          <button
            key={item.id}
            type="button"
            role="tab"
            aria-selected={selectedId === item.id}
            onClick={() => onSelect(item.id)}
            className={`benefits-chip ${selectedId === item.id ? 'benefits-chip--active' : ''}`}
          >
            {item.emoji} {item.label}
          </button>
        ))}
      </div>

      <div className="benefits-card">
        {b ? (
          <div className="benefits-card__content">
            {b.imageFirst ? (
              <>
                <div className="benefits-card__media">
                  <img loading="lazy" src={b.image} className="benefits-card__img" alt={b.imageAlt} />
                </div>
                <div className="benefits-card__text">
                  <h3 className="benefits-card__title">{b.title}</h3>
                  {b.descriptions.map((desc, i) => (
                    <p key={i} className="benefits-card__description">{desc}</p>
                  ))}
                </div>
              </>
            ) : (
              <>
                <div className="benefits-card__text">
                  <h3 className="benefits-card__title">{b.title}</h3>
                  {b.descriptions.map((desc, i) => (
                    <p key={i} className="benefits-card__description">{desc}</p>
                  ))}
                </div>
                <div className="benefits-card__media">
                  <img loading="lazy" src={b.image} className="benefits-card__img" alt={b.imageAlt} />
                </div>
              </>
            )}
          </div>
        ) : null}
      </div>
    </>
  );
}
